module.exports = __webpack_public_path__ + "static/logo-6cc295860716b5f1057ebd0bcbac7d67.png";